<script lang="ts">
  import type { Distributor } from "@shared/types/Distributor";

  export let distributor: Pick<
    Distributor,
    "integrated" | "seven_fifty_integration" | "uses_price_zones"
  >;

  export let additionalClasses: string = "";
  export let tooltipClasses: string = "fizz-tooltip-top fizz-tooltip-left";

  const isIntegrated =
    distributor.integrated || (distributor.seven_fifty_integration && distributor.uses_price_zones);
  const showTooltip = isIntegrated ? "initial" : "none";

  const containerClasses = "fizz-tooltip-container " + additionalClasses;
</script>

<span class={containerClasses} style="display: {showTooltip}">
  <button class="fizz-tooltip-trigger fizz-flex-row" aria-describedby="integrated-price-tooltip">
    <span class="product-detail__integrated-pricing-icon" data-testid="integrated-pricing-icon" />
  </button>
  <span
    class="fizz-tooltip ${tooltipClasses}"
    id="integrated-price-tooltip"
    data-testid="integrated-price-tooltip"
    role="tooltip"
    style="--max-width: 190px;"
  >
    Partner distributors pass their data to Provi to seamlessly process orders.
  </span>
</span>
